import { useState } from "react";
import novaLogo from '../assets/images/NOVA.png';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; 
import { setAuthToken, getAuthHeader } from "../helpers/auth";
import { setUserData } from "../helpers/user";
import { messaging, getToken } from "../firebaseClient";
import { serviceWorkerRegistration } from "../firebaseServiceWorkerRegistration";
import "./AuthLogin.css"; 

const VAPID_KEY =
  "BAd_4ttDtG_bhaiT0-wSgf-eLZ5PTNnl60chQn5c6iiWrABbgoaVVFWbFIgZBSWw6O02jDFGShHM8NpBh_KECYw";

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&family=DM+Mono:wght@400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  @keyframes bootSweep {
    0%   { transform: translateY(-100%); opacity:1; }
    100% { transform: translateY(220vh);  opacity:0; }
  }
  @keyframes fadeIn   { from{opacity:0} to{opacity:1} }
  @keyframes fadeUp   { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
  @keyframes fadeRight{ from{opacity:0;transform:translateX(28px)} to{opacity:1;transform:translateX(0)} }

  @keyframes orb1 {
    0%,100%{transform:translate(0,0) scale(1)}
    33%    {transform:translate(70px,-50px) scale(1.10)}
    66%    {transform:translate(-40px,60px) scale(0.93)}
  }
  @keyframes orb2 {
    0%,100%{transform:translate(0,0) scale(1)}
    40%    {transform:translate(-90px,40px) scale(1.07)}
    70%    {transform:translate(60px,-70px) scale(0.94)}
  }
  @keyframes orb3 {
    0%,100%{transform:translate(0,0) scale(1)}
    30%    {transform:translate(50px,80px) scale(1.14)}
    65%    {transform:translate(-70px,-30px) scale(0.91)}
  }
  @keyframes shimmerSweep {
    0%  {background-position:-300% 0}
    100%{background-position:400% 0}
  }
  @keyframes gridFade {
    0%,100%{opacity:0.028} 50%{opacity:0.062}
  }
  @keyframes floatUp {
    0%  {transform:translate(0,0) scale(1);opacity:var(--op)}
    100%{transform:translate(var(--dx),-130px) scale(0);opacity:0}
  }
  @keyframes logoShine {
    0%  {background-position:-700px center}
    100%{background-position:700px center}
  }
  @keyframes glowPulse {
    0%,100%{opacity:0.55}
    50%    {opacity:1.0}
  }
  @keyframes btnShimmer { 0%{left:-120%} 100%{left:200%} }
  @keyframes spin { to{transform:rotate(360deg)} }
  @keyframes noiseScroll {
    0%  {background-position:0 0}
    100%{background-position:200px 200px}
  }
  @keyframes wristGlow {
    0%,100%{
      filter:drop-shadow(0 0 3px #22D3A5) drop-shadow(0 0 8px rgba(34,211,165,0.70));
      opacity:0.92;
    }
    50%{
      filter:drop-shadow(0 0 6px #22D3A5) drop-shadow(0 0 18px rgba(34,211,165,0.95)) drop-shadow(0 0 28px rgba(59,130,246,0.45));
      opacity:1.0;
    }
  }
  @keyframes workerBob {
    0%,100%{transform:translateY(0)}
    50%    {transform:translateY(-3px)}
  }
  @keyframes workerBob2 {
    0%,100%{transform:translateY(0)}
    50%    {transform:translateY(-4px)}
  }

  /* ── LAYOUT ──────────────────────────────────── */
  .al-root {
    display:flex; width:100%; height:100vh;
    background:#080C18; font-family:'DM Sans',sans-serif;
    overflow:hidden; position:relative;
  }
  .al-boot {
    position:fixed; inset:0;
    background:linear-gradient(180deg,
      transparent 0%,rgba(34,211,165,0.10) 49%,
      rgba(59,130,246,0.08) 51%,transparent 100%
    );
    z-index:9999; pointer-events:none;
    animation:bootSweep 1.0s 0.05s cubic-bezier(0.4,0,0.2,1) both;
  }
  .al-scanlines {
    position:fixed; inset:0;
    background:repeating-linear-gradient(0deg,
      transparent,transparent 2px,
      rgba(0,0,0,0.042) 2px,rgba(0,0,0,0.042) 4px
    );
    pointer-events:none; z-index:9998;
  }

  /* ── LEFT ────────────────────────────────────── */
  .al-left {
    flex:1; position:relative; overflow:hidden; background:#060A15;
  }
  .al-deep-bg {
    position:absolute; inset:0;
    background:
      radial-gradient(ellipse 100% 70% at 50% 110%,rgba(34,211,165,0.060) 0%,transparent 65%),
      radial-gradient(ellipse 80%  60% at 8%  50%, rgba(59,130,246,0.045) 0%,transparent 60%),
      radial-gradient(ellipse 55%  45% at 92% 18%, rgba(167,139,250,0.025) 0%,transparent 55%),
      linear-gradient(165deg,#060A16 0%,#080D1B 50%,#050914 100%);
  }
  .al-noise {
    position:absolute; inset:0; opacity:0.020;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
    background-size:200px 200px; animation:noiseScroll 8s linear infinite;
    pointer-events:none; z-index:1;
  }
  .al-orb { position:absolute; border-radius:50%; filter:blur(90px); pointer-events:none; z-index:2; }
  .al-orb-1 { width:520px;height:520px;left:-80px;top:-60px;   background:radial-gradient(circle,rgba(59,130,246,0.20) 0%,transparent 70%);animation:orb1 18s ease-in-out infinite; }
  .al-orb-2 { width:600px;height:600px;right:-120px;bottom:-80px; background:radial-gradient(circle,rgba(34,211,165,0.17) 0%,transparent 70%);animation:orb2 22s ease-in-out infinite; }
  .al-orb-3 { width:400px;height:400px;left:32%;top:18%;       background:radial-gradient(circle,rgba(167,139,250,0.08) 0%,transparent 70%);animation:orb3 15s ease-in-out infinite; }
  .al-shimmer {
    position:absolute; inset:0; pointer-events:none; z-index:3;
    background:linear-gradient(105deg,
      transparent 0%,transparent 38%,
      rgba(59,130,246,0.033) 46%,rgba(34,211,165,0.052) 50%,
      rgba(59,130,246,0.033) 54%,transparent 62%,transparent 100%
    );
    background-size:300% 100%; animation:shimmerSweep 8s 2s ease-in-out infinite;
  }
  .al-grid {
    position:absolute; inset:0; z-index:3; pointer-events:none;
    background-image:
      linear-gradient(rgba(59,130,246,1) 1px,transparent 1px),
      linear-gradient(90deg,rgba(59,130,246,1) 1px,transparent 1px);
    background-size:64px 64px; background-position:center center;
    animation:gridFade 6s ease-in-out infinite;
  }
  .al-hline {
    position:absolute; left:0; right:0; height:1px; pointer-events:none; z-index:4;
    background:linear-gradient(90deg,
      transparent 0%,rgba(34,211,165,0.11) 20%,
      rgba(34,211,165,0.28) 50%,rgba(59,130,246,0.11) 80%,transparent 100%
    );
  }
  .al-scene { position:absolute; bottom:0; left:0; right:0; z-index:6; pointer-events:none; }
  .al-particle {
    position:absolute; border-radius:50%;
    animation:floatUp ease-out infinite; z-index:5; pointer-events:none;
  }
  .al-left-inner {
    position:absolute; inset:0; z-index:10;
    display:flex; flex-direction:column; justify-content:space-between;
    padding:52px 60px 52px;
  }
  .al-brand { animation:fadeUp 0.8s 1.5s both; }
  .al-brand-mark {
    font-family:'Bebas Neue',sans-serif; font-size:72px; letter-spacing:0.06em; line-height:0.85;
    background:linear-gradient(105deg,#fff 0%,#BAE6FD 15%,#3B82F6 30%,#22D3A5 50%,#3B82F6 68%,#fff 85%,#fff 100%);
    background-size:700px 100%; -webkit-background-clip:text;
    -webkit-text-fill-color:transparent; background-clip:text;
    animation:logoShine 5s 3.0s ease-in-out infinite; display:block;
  }
  .al-brand-sub {
    display:block; font-family:'DM Mono',monospace; font-size:10px;
    letter-spacing:0.28em; color:rgba(34,211,165,0.42); margin-top:6px; text-transform:uppercase;
  }
  .al-hero { display:flex; flex-direction:column; gap:16px; }
  .al-hero-eyebrow { display:flex; align-items:center; gap:10px; animation:fadeUp 0.8s 1.8s both; }
  .al-eyebrow-line { height:1px; width:32px; background:linear-gradient(90deg,#3B82F6,#22D3A5); display:inline-block; }
  .al-eyebrow-text { font-size:10px; font-weight:700; letter-spacing:0.20em; color:rgba(34,211,165,0.58); text-transform:uppercase; }
  .al-hero-title {
    font-size:clamp(40px,4.2vw,60px); font-weight:800; color:rgba(255,255,255,0.90);
    letter-spacing:-0.04em; line-height:1.07; max-width:460px; animation:fadeUp 0.9s 2.0s both;
  }
  .al-hero-title em {
    font-style:normal;
    background:linear-gradient(90deg,#3B82F6 0%,#22D3A5 100%);
    -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
  }
  .al-hero-body {
    font-size:13px; color:rgba(255,255,255,0.22); font-weight:400;
    line-height:1.75; max-width:360px; animation:fadeUp 0.9s 2.2s both;
  }
  .al-powered-wrap { display:flex; flex-direction:column; gap:12px; animation:fadeUp 0.8s 2.6s both; }
  .al-powered-divider { height:1px; width:180px; background:linear-gradient(90deg,rgba(34,211,165,0.20),rgba(59,130,246,0.15),transparent); }
  .al-powered-label { font-family:'DM Mono',monospace; font-size:9px; letter-spacing:0.18em; color:rgba(255,255,255,0.16); text-transform:uppercase; }
  .al-powered-novaa { display:inline-flex; align-items:center; gap:10px; margin-top:2px; }
  .al-novaa-img {
    height:32px; width:auto; object-fit:contain;
    filter:brightness(1.15) drop-shadow(0 0 8px rgba(34,211,165,0.50));
    animation:glowPulse 3s ease-in-out infinite;
  }
  .al-novaa-fallback {
    display:flex; align-items:center; gap:8px;
  }
  .al-novaa-icon {
    width:28px; height:28px; border-radius:8px;
    background:linear-gradient(135deg,#3B82F6,#22D3A5);
    display:flex; align-items:center; justify-content:center;
    font-family:'Bebas Neue',sans-serif; font-size:16px; color:#fff;
    box-shadow:0 0 14px rgba(34,211,165,0.45); animation:glowPulse 3s ease-in-out infinite;
  }
  .al-novaa-word {
    font-family:'Bebas Neue',sans-serif; font-size:24px; letter-spacing:0.12em;
    background:linear-gradient(90deg,#3B82F6,#22D3A5);
    -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
  }

  /* ── DIVIDER ─────────────────────────────────── */
  .al-divider {
    width:1px; flex-shrink:0; position:relative;
    background:linear-gradient(180deg,transparent 0%,rgba(255,255,255,0.050) 15%,rgba(255,255,255,0.050) 85%,transparent 100%);
  }
  .al-divider-gem {
    position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);
    width:8px; height:8px; border-radius:50%;
    background:linear-gradient(135deg,#3B82F6,#22D3A5);
    box-shadow:0 0 16px 4px rgba(34,211,165,0.32); animation:glowPulse 2.5s ease-in-out infinite;
  }

  /* ── RIGHT ───────────────────────────────────── */
  .al-right {
    width:460px; flex-shrink:0; display:flex; align-items:center; justify-content:center;
    background:#080C18; position:relative; overflow:hidden; padding:48px 44px;
  }
  .al-right::before {
    content:''; position:absolute; inset:0; pointer-events:none;
    background:
      radial-gradient(ellipse 90% 50% at 50% 0%,  rgba(59,130,246,0.042) 0%,transparent 70%),
      radial-gradient(ellipse 70% 40% at 50% 100%,rgba(34,211,165,0.032) 0%,transparent 65%);
  }
  .al-bracket { position:absolute; width:48px; height:48px; pointer-events:none; z-index:5; }
  .al-bracket-tr { top:22px;right:22px; border-top:1px solid rgba(34,211,165,0.16); border-right:1px solid rgba(34,211,165,0.16); border-radius:0 8px 0 0; animation:fadeIn 1s 2.8s both; }
  .al-bracket-bl { bottom:22px;left:22px; border-bottom:1px solid rgba(59,130,246,0.16); border-left:1px solid rgba(59,130,246,0.16); border-radius:0 0 0 8px; animation:fadeIn 1s 2.8s both; }
  .al-card { width:100%; max-width:360px; position:relative; z-index:10; }
  .al-card-head { margin-bottom:36px; animation:fadeRight 0.7s 1.6s both; }
  .al-eyebrow-row { display:flex; align-items:center; gap:8px; margin-bottom:13px; }
  .al-eyebrow-dash { height:1px; width:22px; background:linear-gradient(90deg,#3B82F6,#22D3A5); }
  .al-eyebrow-tag { font-size:9px; font-weight:700; letter-spacing:0.18em; color:rgba(34,211,165,0.52); text-transform:uppercase; }
  .al-card-title { font-size:32px; font-weight:800; color:#fff; letter-spacing:-0.04em; line-height:1.05; margin-bottom:8px; }
  .al-card-sub { font-size:12px; color:rgba(255,255,255,0.24); font-weight:400; line-height:1.6; }
  .al-field { margin-bottom:18px; }
  .al-field:nth-child(1){animation:fadeRight 0.7s 1.9s both}
  .al-field:nth-child(2){animation:fadeRight 0.7s 2.05s both}
  .al-field:nth-child(3){animation:fadeRight 0.7s 2.20s both}
  .al-label { display:flex; justify-content:space-between; align-items:center; font-size:10px; font-weight:700; color:rgba(255,255,255,0.28); letter-spacing:0.12em; text-transform:uppercase; margin-bottom:8px; }
  .al-label a { text-decoration:none; color:rgba(34,211,165,0.48); font-weight:600; letter-spacing:0.04em; text-transform:none; font-size:11px; transition:color 0.2s; }
  .al-label a:hover { color:#22D3A5; }
  .al-input-wrap { position:relative; }
  .al-input-icon { position:absolute; left:14px; top:50%; transform:translateY(-50%); color:rgba(255,255,255,0.17); font-size:14px; line-height:1; pointer-events:none; z-index:2; }
  .al-input {
    width:100%; padding:14px 14px 14px 42px;
    background:rgba(255,255,255,0.036); border:1px solid rgba(255,255,255,0.075);
    border-radius:11px; color:#E2E8F0; font-size:13px;
    font-family:'DM Sans',sans-serif; font-weight:500;
    outline:none; transition:border-color 0.2s,background 0.2s,box-shadow 0.2s; color-scheme:dark;
  }
  .al-input::placeholder { color:rgba(255,255,255,0.14); }
  .al-input:focus { border-color:rgba(34,211,165,0.38); background:rgba(34,211,165,0.032); box-shadow:0 0 0 3px rgba(34,211,165,0.07),0 0 14px rgba(34,211,165,0.09); }
  .al-input.has-error { border-color:rgba(248,113,113,0.38); background:rgba(248,113,113,0.032); }
  @keyframes shake{0%,100%{transform:translateX(0)}20%,60%{transform:translateX(-4px)}40%,80%{transform:translateX(4px)}}
  .al-uline { position:absolute; bottom:-1px; left:10px; right:10px; height:2px; border-radius:2px; background:linear-gradient(90deg,#3B82F6,#22D3A5); transform:scaleX(0); transform-origin:left; transition:transform 0.3s cubic-bezier(0.4,0,0.2,1); }
  .al-input:focus ~ .al-uline { transform:scaleX(1); }
  .al-error-msg { font-size:10px; color:#F87171; font-weight:700; margin-top:5px; display:flex; align-items:center; gap:5px; animation:fadeUp 0.2s ease both; }
  .al-eye { position:absolute; right:13px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:rgba(255,255,255,0.19); font-size:13px; padding:4px; transition:color 0.2s; z-index:2; }
  .al-eye:hover { color:rgba(255,255,255,0.48); }
  .al-alert { background:rgba(248,113,113,0.07); border:1px solid rgba(248,113,113,0.20); border-radius:9px; padding:10px 13px; font-size:11px; color:#F87171; font-weight:600; display:flex; align-items:center; gap:7px; margin-bottom:16px; animation:fadeUp 0.25s ease both; }
  .al-btn {
    width:100%; padding:15px; border:none; border-radius:12px;
    background:linear-gradient(90deg,#3B82F6 0%,#22D3A5 50%,#3B82F6 100%);
    background-size:200% 100%; background-position:100% 0; color:#fff;
    font-family:'DM Sans',sans-serif; font-size:13px; font-weight:800;
    letter-spacing:0.10em; text-transform:uppercase; cursor:pointer;
    position:relative; overflow:hidden;
    transition:background-position 0.5s ease,transform 0.15s,box-shadow 0.3s;
    box-shadow:0 4px 22px rgba(34,211,165,0.20),0 1px 0 rgba(255,255,255,0.07) inset;
    animation:fadeRight 0.7s 2.35s both;
  }
  .al-btn:hover:not(:disabled){ background-position:0 0; box-shadow:0 6px 36px rgba(34,211,165,0.36); transform:translateY(-1px); }
  .al-btn:active:not(:disabled){ transform:translateY(0); }
  .al-btn:disabled{ opacity:0.5; cursor:not-allowed; transform:none; }
  .al-btn-shine { position:absolute; top:0; left:-120%; width:55%; height:100%; background:linear-gradient(90deg,transparent,rgba(255,255,255,0.18),transparent); animation:btnShimmer 2.8s 4.5s ease-in-out infinite; }
  .al-footer { text-align:center; margin-top:22px; font-size:11px; color:rgba(255,255,255,0.18); animation:fadeRight 0.7s 2.5s both; }
  .al-footer a { color:rgba(34,211,165,0.48); text-decoration:none; font-weight:600; transition:color 0.2s; }
  .al-footer a:hover { color:#22D3A5; }
  .al-spin { display:inline-block; width:13px; height:13px; border:2px solid rgba(255,255,255,0.25); border-top-color:white; border-radius:50%; animation:spin 0.7s linear infinite; vertical-align:middle; margin-right:7px; }
`;

const PARTICLES = Array.from({ length: 28 }, (_, i) => ({
  id: i,
  x: 5 + Math.random() * 90,
  y: 5 + Math.random() * 58,
  delay: Math.random() * 6,
  dur: 3.5 + Math.random() * 4,
  dx: `${-20 + Math.random() * 40}px`,
  size: 1 + Math.random() * 2,
  op: 0.10 + Math.random() * 0.32,
  color: i % 3 === 0 ? 'rgba(34,211,165,0.85)' : i % 3 === 1 ? 'rgba(59,130,246,0.85)' : 'rgba(167,139,250,0.60)',
}));

// ─── SHARED DEFS ─────────────────────────────────────────────────
const SceneDefs = () => (
  <defs>
    <linearGradient id="panelBody" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stopColor="#0D1F3C"/>
      <stop offset="100%" stopColor="#07101E"/>
    </linearGradient>
    <linearGradient id="panelGlare" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stopColor="rgba(59,130,246,0.22)"/>
      <stop offset="60%" stopColor="rgba(34,211,165,0.06)"/>
      <stop offset="100%" stopColor="transparent"/>
    </linearGradient>
    <linearGradient id="groundGrad" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stopColor="#0A1428"/>
      <stop offset="100%" stopColor="#050C18"/>
    </linearGradient>
    <linearGradient id="silFill" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stopColor="#0C1830"/>
      <stop offset="100%" stopColor="#060E1C"/>
    </linearGradient>
    <linearGradient id="invGrad" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stopColor="#0F2040"/>
      <stop offset="100%" stopColor="#081526"/>
    </linearGradient>
    <radialGradient id="fogGrad" cx="50%" cy="100%" r="60%">
      <stop offset="0%" stopColor="rgba(34,211,165,0.07)"/>
      <stop offset="100%" stopColor="transparent"/>
    </radialGradient>
    <filter id="wristFilt" x="-120%" y="-120%" width="340%" height="340%">
      <feGaussianBlur in="SourceGraphic" stdDeviation="2.8" result="blur"/>
      <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
    </filter>
    <filter id="ledGlow" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur"/>
      <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
    </filter>
  </defs>
);

// ─── WRISTBAND COMPONENT ─────────────────────────────────────────
const Wristband = ({ x, y, delay = "0s" }) => (
  <g filter="url(#wristFilt)" style={{ animation: `wristGlow 2.2s ${delay} ease-in-out infinite` }}>
    <rect x={x} y={y} width={12} height={6} rx="2.5" fill="#22D3A5" opacity="0.95"/>
    <rect x={x} y={y} width={12} height={6} rx="2.5" fill="none" stroke="rgba(59,130,246,0.6)" strokeWidth="0.5"/>
    {/* two beacon rings */}
    <circle cx={x + 6} cy={y + 3} r="3" fill="none" stroke="rgba(34,211,165,0.70)" strokeWidth="1.1">
      <animate attributeName="r" values="3;16" dur="2.2s" begin={delay} repeatCount="indefinite"/>
      <animate attributeName="opacity" values="0.8;0" dur="2.2s" begin={delay} repeatCount="indefinite"/>
    </circle>
    <circle cx={x + 6} cy={y + 3} r="3" fill="none" stroke="rgba(59,130,246,0.40)" strokeWidth="0.8">
      <animate attributeName="r" values="3;11" dur="2.2s" begin={`calc(${delay} + 0.8s)`} repeatCount="indefinite"/>
      <animate attributeName="opacity" values="0.5;0" dur="2.2s" begin={`calc(${delay} + 0.8s)`} repeatCount="indefinite"/>
    </circle>
  </g>
);

// ─── SVG SCENE ───────────────────────────────────────────────────
const Scene = () => (
  <svg viewBox="0 0 900 420" preserveAspectRatio="xMidYMax meet"
    style={{ width: '100%', display: 'block' }} xmlns="http://www.w3.org/2000/svg">

    <SceneDefs/>

    {/* Ground */}
    <rect x="0" y="370" width="900" height="50" fill="url(#groundGrad)"/>
    <line x1="0" y1="370" x2="900" y2="370" stroke="rgba(34,211,165,0.10)" strokeWidth="1"/>
    <ellipse cx="450" cy="372" rx="440" ry="24" fill="url(#fogGrad)">
      <animate attributeName="rx" values="400;460;400" dur="8s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="0.6;1.0;0.6" dur="7s" repeatCount="indefinite"/>
    </ellipse>

    {/* ── BACKGROUND: distant small panel cluster (depth/atmosphere) ── */}
    <g opacity="0.35">
      <rect x="820" y="285" width="4" height="85" fill="#0A1525"/>
      <rect x="868" y="278" width="4" height="92" fill="#0A1525"/>
      <rect x="820" y="283" width="52" height="3" fill="#0A1525"/>
      {[0, 1].map(i => (
        <g key={i}>
          <rect x={822 + i*26} y={287} width={22} height={72} rx="2"
            fill="url(#panelBody)" stroke="rgba(59,130,246,0.18)" strokeWidth="0.6"/>
          <rect x={822 + i*26} y={287} width={13} height={36} rx="1"
            fill="url(#panelGlare)" opacity="0.45"/>
          <line x1={822+i*26+11} y1={291} x2={822+i*26+11} y2={355}
            stroke="rgba(59,130,246,0.14)" strokeWidth="0.5"/>
        </g>
      ))}
    </g>

    {/* ══════════════════════════════════════════════════════════
        ZONE 1 — INVERTER STATION + TECHNICIAN
    ══════════════════════════════════════════════════════════ */}

    {/* Wall/post mounting */}
    <rect x="148" y="218" width="7" height="152" rx="2" fill="#0A1628"/>

    {/* ── Main inverter enclosure ── */}
    <rect x="100" y="205" width="80" height="115" rx="5"
      fill="url(#invGrad)" stroke="rgba(59,130,246,0.28)" strokeWidth="1"/>
    {/* inner bezel */}
    <rect x="105" y="210" width="70" height="105" rx="3"
      fill="none" stroke="rgba(59,130,246,0.11)" strokeWidth="0.8"/>
    {/* brand plate */}
    <rect x="110" y="215" width="60" height="12" rx="2"
      fill="rgba(59,130,246,0.09)" stroke="rgba(59,130,246,0.16)" strokeWidth="0.6"/>
    <rect x="115" y="219" width="30" height="2.5" rx="1" fill="rgba(34,211,165,0.25)"/>
    {/* ventilation slots top section */}
    {[0,1,2,3,4].map(i => (
      <line key={i} x1="110" y1={233+i*4} x2="170" y2={233+i*4}
        stroke="rgba(59,130,246,0.14)" strokeWidth="0.8"/>
    ))}

    {/* ── LCD / readout display ── */}
    <rect x="110" y="258" width="60" height="38" rx="3"
      fill="rgba(8,20,42,0.90)" stroke="rgba(59,130,246,0.25)" strokeWidth="0.8"/>
    {/* data rows on display */}
    {[
      { y: 265, w: 32, color: 'rgba(34,211,165,0.55)', dur: '2.1s' },
      { y: 272, w: 44, color: 'rgba(59,130,246,0.45)', dur: '3.0s' },
      { y: 279, w: 26, color: 'rgba(34,211,165,0.40)', dur: '1.7s' },
      { y: 286, w: 38, color: 'rgba(59,130,246,0.35)', dur: '2.6s' },
    ].map((row, i) => (
      <rect key={i} x="114" y={row.y} width={row.w} height="2" rx="1" fill={row.color}>
        <animate attributeName="width" values={`${row.w};${row.w-12};${row.w}`}
          dur={row.dur} repeatCount="indefinite"/>
      </rect>
    ))}
    {/* display cursor blink */}
    <rect x="114" y="289" width="4" height="2" rx="1" fill="rgba(34,211,165,0.80)">
      <animate attributeName="opacity" values="1;0;1" dur="1.0s" repeatCount="indefinite"/>
    </rect>

    {/* ── LED indicators ── */}
    <g filter="url(#ledGlow)">
      <circle cx="157" cy="215" r="3.5" fill="#22D3A5">
        <animate attributeName="opacity" values="1;0.15;1" dur="1.9s" repeatCount="indefinite"/>
      </circle>
      <circle cx="165" cy="215" r="3.5" fill="#3B82F6" opacity="0.75">
        <animate attributeName="opacity" values="0.75;0.20;0.75" dur="2.7s" begin="0.5s" repeatCount="indefinite"/>
      </circle>
    </g>

    {/* ── Terminal block / cable connections at bottom ── */}
    <rect x="110" y="303" width="60" height="13" rx="2"
      fill="rgba(59,130,246,0.07)" stroke="rgba(59,130,246,0.18)" strokeWidth="0.7"/>
    {/* terminal bolts */}
    {[0,1,2,3].map(i => (
      <circle key={i} cx={116+i*14} cy={309.5} r="2.8"
        fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="0.8"/>
    ))}
    {/* screw notch on each */}
    {[0,1,2,3].map(i => (
      <line key={i} x1={116+i*14-1.5} y1={309.5} x2={116+i*14+1.5} y2={309.5}
        stroke="rgba(255,255,255,0.15)" strokeWidth="0.6"/>
    ))}

    {/* Cable conduits down to ground */}
    <rect x="130" y="318" width="6" height="52" rx="2" fill="#091422"/>
    <rect x="140" y="320" width="4" height="50" rx="1" fill="#0A1626"/>
    <line x1="118" y1="316" x2="112" y2="370" stroke="rgba(34,211,165,0.18)" strokeWidth="1.8"/>
    <line x1="160" y1="316" x2="166" y2="370" stroke="rgba(59,130,246,0.15)" strokeWidth="1.8"/>
    {/* DC input cables from top */}
    <path d="M125,205 Q118,185 108,172" fill="none" stroke="rgba(59,130,246,0.18)" strokeWidth="2"/>
    <path d="M155,205 Q162,183 172,170" fill="none" stroke="rgba(34,211,165,0.14)" strokeWidth="2"/>

    {/* ── WORKER 1 — inverter technician ── */}
    {/* Slight bob */}
    <g style={{ animation: 'workerBob 4.5s ease-in-out infinite', transformOrigin: '220px 370px' }}>
      {/* legs */}
      <rect x="212" y="340" width="10" height="30" rx="3" fill="url(#silFill)"/>
      <rect x="226" y="340" width="10" height="30" rx="3" fill="url(#silFill)"/>
      {/* boots */}
      <rect x="210" y="366" width="14" height="6" rx="2" fill="#060E1C"/>
      <rect x="224" y="366" width="14" height="6" rx="2" fill="#060E1C"/>
      {/* torso — faces LEFT toward inverter */}
      <rect x="208" y="292" width="30" height="50" rx="5" fill="url(#silFill)"/>
      <rect x="208" y="292" width="30" height="50" rx="5" fill="rgba(59,130,246,0.05)"/>
      {/* safety vest stripe */}
      <rect x="208" y="316" width="30" height="3" rx="1" fill="rgba(251,191,36,0.08)"/>

      {/* LEFT arm extended toward inverter terminal */}
      <rect x="180" y="306" width="30" height="9" rx="4" fill="url(#silFill)"/>

      {/* ── Handheld probe / multimeter tester ── */}
      {/* probe body */}
      <rect x="165" y="303" width="16" height="8" rx="2"
        fill="#0E1E36" stroke="rgba(59,130,246,0.32)" strokeWidth="0.8"/>
      {/* small led on tester */}
      <circle cx="176" cy="307" r="1.8" fill="#22D3A5" filter="url(#ledGlow)">
        <animate attributeName="opacity" values="1;0.1;1" dur="1.3s" repeatCount="indefinite"/>
      </circle>
      {/* probe tip wire going to terminal */}
      <line x1="165" y1="307" x2="152" y2="310" stroke="#22D3A5" strokeWidth="1.4"
        strokeDasharray="3,2">
        <animate attributeName="strokeDashoffset" values="0;5" dur="0.8s" repeatCount="indefinite"/>
      </line>

      {/* right arm resting down */}
      <rect x="237" y="295" width="9" height="32" rx="4" fill="url(#silFill)"/>
      {/* neck */}
      <rect x="217" y="277" width="12" height="16" rx="4" fill="url(#silFill)"/>
      {/* head — turned slightly left */}
      <ellipse cx="222" cy="267" rx="15" ry="16" fill="url(#silFill)"/>
      {/* hard hat */}
      <ellipse cx="222" cy="254" rx="17" ry="7" fill="#0C1830"/>
      <rect x="206" y="251" width="32" height="8" rx="3" fill="#0D1E36"/>

      {/* ── WRISTBAND — left wrist ── */}
      <Wristband x={178} y={308} delay="0s"/>
    </g>

    {/* ground glow under worker 1 */}
    <ellipse cx="220" cy="372" rx="26" ry="5" fill="rgba(34,211,165,0.05)">
      <animate attributeName="opacity" values="0.4;0.9;0.4" dur="2s" repeatCount="indefinite"/>
    </ellipse>

    {/* ══════════════════════════════════════════════════════════
        ZONE 2 — INCLINED PANELS (SIDE VIEW) + MOPPING WORKER
    ══════════════════════════════════════════════════════════ */}

    {/* ── Panel array structure — side view ── */}
    {/* Rear tall post */}
    <rect x="573" y="183" width="9" height="187" rx="2" fill="#0D1E38"/>
    {/* Front shorter post */}
    <rect x="432" y="295" width="9" height="75" rx="2" fill="#0D1E38"/>
    {/* Main diagonal cross brace */}
    <line x1="437" y1="315" x2="577" y2="252"
      stroke="#0A1628" strokeWidth="4.5" strokeLinecap="round"/>
    {/* secondary brace */}
    <line x1="437" y1="340" x2="500" y2="290"
      stroke="#0A1628" strokeWidth="3" strokeLinecap="round" opacity="0.7"/>
    {/* Ground anchor feet */}
    <rect x="427" y="366" width="18" height="5" rx="2" fill="#0A1628"/>
    <rect x="568" y="366" width="18" height="5" rx="2" fill="#0A1628"/>
    {/* anchor bolts */}
    {[429,434,439].map(x => (
      <circle key={x} cx={x} cy={370} r="1.5" fill="rgba(255,255,255,0.12)"/>
    ))}
    {[570,575,580].map(x => (
      <circle key={x} cx={x} cy={370} r="1.5" fill="rgba(255,255,255,0.12)"/>
    ))}

    {/* ── Solar panel faces — 3 layers for depth (side/perspective view) ── */}
    {/* Corners: front-bottom(436,316) front-top(436,297) rear-top(578,207) rear-bottom(578,226) */}
    {/* Layer 3 — deepest, most faded */}
    <polygon points="448,326 592,236 592,217 448,307"
      fill="url(#panelBody)" stroke="rgba(59,130,246,0.13)" strokeWidth="0.7" opacity="0.60"/>
    {/* Layer 2 — middle */}
    <polygon points="442,320 586,230 586,211 442,301"
      fill="url(#panelBody)" stroke="rgba(59,130,246,0.20)" strokeWidth="0.8" opacity="0.80"/>
    {/* Layer 1 — front, most detail */}
    <polygon points="436,314 580,224 580,205 436,295"
      fill="url(#panelBody)" stroke="rgba(59,130,246,0.32)" strokeWidth="1.0"/>

    {/* Panel face grid — horizontal lines (parallel to short axis) */}
    {[0.25, 0.50, 0.75].map((f, i) => {
      // Interpolate along the two vertical edges of the front panel face
      // Left edge: (436,295) at top → (436,314) at bottom; BUT we treat f=0 as top-right and f=1 as bottom-right
      // Actually: top edge (436,295)→(580,205), bottom edge (436,314)→(580,224)
      // A horizontal "band" at fraction f along the left edge:
      const lx = 436, ly = 295 + f * (314 - 295); // left edge point
      const rx = 580, ry = 205 + f * (224 - 205); // right edge point
      return (
        <line key={i} x1={lx} y1={ly} x2={rx} y2={ry}
          stroke="rgba(59,130,246,0.18)" strokeWidth="0.7"/>
      );
    })}
    {/* Panel face grid — vertical lines */}
    {[0.20, 0.40, 0.60, 0.80].map((f, i) => {
      // Interpolate along top and bottom edges
      const topX = 436 + f * (580 - 436), topY = 295 + f * (205 - 295);
      const botX = 436 + f * (580 - 436), botY = 314 + f * (224 - 314);
      return (
        <line key={i} x1={topX} y1={topY} x2={botX} y2={botY}
          stroke="rgba(59,130,246,0.16)" strokeWidth="0.6"/>
      );
    })}

    {/* Panel glare — top-left quadrant of front face */}
    <polygon points="436,295 500,259 500,248 436,284"
      fill="url(#panelGlare)" opacity="0.85">
      <animate attributeName="opacity" values="0.45;0.95;0.45" dur="4.5s" repeatCount="indefinite"/>
    </polygon>

    {/* Panel top-edge highlight */}
    <line x1="436" y1="295" x2="580" y2="205"
      stroke="rgba(251,191,36,0.10)" strokeWidth="1.2"/>

    {/* ── WORKER 2 — mopping from side ── */}
    {/* Worker stands to the LEFT of the panel, facing RIGHT */}
    <g style={{ animation: 'workerBob2 3.5s 0.4s ease-in-out infinite', transformOrigin: '398px 370px' }}>
      {/* legs */}
      <rect x="390" y="340" width="10" height="30" rx="3" fill="url(#silFill)"/>
      <rect x="404" y="340" width="10" height="30" rx="3" fill="url(#silFill)"/>
      {/* boots */}
      <rect x="388" y="366" width="14" height="6" rx="2" fill="#060E1C"/>
      <rect x="402" y="366" width="14" height="6" rx="2" fill="#060E1C"/>
      {/* torso — faces RIGHT toward panels */}
      <rect x="386" y="292" width="30" height="50" rx="5" fill="url(#silFill)"/>
      <rect x="386" y="292" width="30" height="50" rx="5" fill="rgba(34,211,165,0.04)"/>
      {/* safety vest stripe */}
      <rect x="386" y="316" width="30" height="3" rx="1" fill="rgba(251,191,36,0.07)"/>
      {/* left hand holding bottom of pole */}
      <rect x="379" y="322" width="9" height="24" rx="4" fill="url(#silFill)"/>

      {/* ── RIGHT ARM + MOP — animated sweep along panel angle ── */}
      {/* Uses SVG animateTransform for correct SVG-unit movement */}
      {/* Panel angle: rise/run = (314-295)/(436-436) — not useful. 
          Panel angle from bottom-left(436,314) to top-right(580,205): 
          dx=144, dy=-109 → for 58px horizontal move: dy = -58*(109/144) = -44 */}
      <g>
        {/* upper right arm — shoulder to elbow */}
        <line x1="415" y1="300" x2="432" y2="308" stroke="url(#silFill)" strokeWidth="9" strokeLinecap="round"/>
        {/* forearm — elbow toward panel */}
        <line x1="432" y1="308" x2="455" y2="295" stroke="url(#silFill)" strokeWidth="8" strokeLinecap="round"/>
        {/* mop/squeegee handle — long pole */}
        <line x1="455" y1="295" x2="496" y2="272" stroke="#0E1E36" strokeWidth="3.5" strokeLinecap="round"/>
        {/* squeegee head — perpendicular to panel face */}
        <rect x="491" y="261" width="18" height="11" rx="2"
          fill="#0F2040" stroke="rgba(59,130,246,0.35)" strokeWidth="0.9"/>
        {/* rubber blade */}
        <line x1="492" y1="272" x2="508" y2="272"
          stroke="rgba(34,211,165,0.50)" strokeWidth="2.2"/>
        {/* water droplets being wiped */}
        <circle cx="505" cy="275" r="1.5" fill="rgba(34,211,165,0.35)">
          <animate attributeName="opacity" values="0.6;0;0.6" dur="1.2s" repeatCount="indefinite"/>
          <animate attributeName="cy" values="275;280;275" dur="1.2s" repeatCount="indefinite"/>
        </circle>
        <circle cx="510" cy="274" r="1" fill="rgba(59,130,246,0.30)">
          <animate attributeName="opacity" values="0.5;0;0.5" dur="1.2s" begin="0.4s" repeatCount="indefinite"/>
          <animate attributeName="cy" values="274;279;274" dur="1.2s" begin="0.4s" repeatCount="indefinite"/>
        </circle>

        {/* ── WRISTBAND on right wrist — moves WITH mop arm ── */}
        <g filter="url(#wristFilt)" style={{ animation: 'wristGlow 2.2s 0.4s ease-in-out infinite' }}>
          <rect x="428" y="305" width="12" height="6" rx="2.5" fill="#22D3A5" opacity="0.95"/>
          <rect x="428" y="305" width="12" height="6" rx="2.5" fill="none" stroke="rgba(59,130,246,0.6)" strokeWidth="0.5"/>
          <circle cx="434" cy="308" r="3" fill="none" stroke="rgba(34,211,165,0.70)" strokeWidth="1.1">
            <animate attributeName="r" values="3;16" dur="2.2s" begin="0.4s" repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0.8;0" dur="2.2s" begin="0.4s" repeatCount="indefinite"/>
          </circle>
          <circle cx="434" cy="308" r="3" fill="none" stroke="rgba(59,130,246,0.40)" strokeWidth="0.8">
            <animate attributeName="r" values="3;11" dur="2.2s" begin="1.2s" repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0.5;0" dur="2.2s" begin="1.2s" repeatCount="indefinite"/>
          </circle>
        </g>

        {/* SVG animateTransform — sweeps along panel surface angle */}
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0,0; 58,-44; 0,0"
          dur="2.8s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines="0.45 0 0.55 1; 0.45 0 0.55 1"
          keyTimes="0;0.5;1"
        />
      </g>

      {/* neck */}
      <rect x="395" y="277" width="12" height="16" rx="4" fill="url(#silFill)"/>
      {/* head */}
      <ellipse cx="400" cy="267" rx="15" ry="16" fill="url(#silFill)"/>
      {/* hard hat */}
      <ellipse cx="400" cy="254" rx="17" ry="7" fill="#0C1830"/>
      <rect x="384" y="251" width="32" height="8" rx="3" fill="#0D1E36"/>
    </g>

    {/* ground glow under worker 2 */}
    <ellipse cx="398" cy="372" rx="24" ry="5" fill="rgba(34,211,165,0.05)">
      <animate attributeName="opacity" values="0.4;0.9;0.4" dur="2.8s" begin="0.4s" repeatCount="indefinite"/>
    </ellipse>

    {/* ══════════════════════════════════════════════════════════
        ZONE 3 — FAR RIGHT (UNCHANGED — MONITORING WORKER)
    ══════════════════════════════════════════════════════════ */}

    {/* Right panel array */}
    <g opacity="0.55">
      <rect x="712" y="258" width="6" height="112" fill="#0B1626"/>
      <rect x="788" y="250" width="6" height="120" fill="#0B1626"/>
      <rect x="712" y="256" width="82" height="4" fill="#0B1626"/>
      <line x1="720" y1="280" x2="712" y2="340" stroke="#0A1628" strokeWidth="3"/>
      <line x1="786" y1="252" x2="792" y2="320" stroke="#0A1628" strokeWidth="3"/>
      {[0, 1, 2].map(c => (
        <g key={c}>
          <rect x={715 + c*27} y={261} width={22} height={100} rx="2"
            fill="url(#panelBody)" stroke="rgba(59,130,246,0.24)" strokeWidth="0.7">
            <animate attributeName="fill-opacity" values="0.85;1;0.85"
              dur={`${3.5+c*0.4}s`} repeatCount="indefinite"/>
          </rect>
          <rect x={715 + c*27} y={261} width={13} height={50} rx="1"
            fill="url(#panelGlare)" opacity="0.55">
            <animate attributeName="opacity" values="0.3;0.7;0.3"
              dur={`${4.5+c*0.3}s`} repeatCount="indefinite"/>
          </rect>
          <line x1={715+c*27+11} y1={265} x2={715+c*27+11} y2={357}
            stroke="rgba(59,130,246,0.16)" strokeWidth="0.5"/>
          <line x1={715+c*27+2} y1={297} x2={715+c*27+20} y2={297}
            stroke="rgba(59,130,246,0.16)" strokeWidth="0.5"/>
        </g>
      ))}
    </g>

    {/* Worker 3 — monitoring, both arms up slightly */}
    <g style={{ animation: 'workerBob 5s 1s ease-in-out infinite', transformOrigin: '775px 370px' }}>
      <rect x="767" y="340" width="10" height="30" rx="3" fill="url(#silFill)"/>
      <rect x="781" y="340" width="10" height="30" rx="3" fill="url(#silFill)"/>
      <rect x="765" y="366" width="14" height="6" rx="2" fill="#060E1C"/>
      <rect x="779" y="366" width="14" height="6" rx="2" fill="#060E1C"/>
      <rect x="764" y="293" width="30" height="50" rx="5" fill="url(#silFill)"/>
      <rect x="764" y="293" width="30" height="50" rx="5" fill="rgba(59,130,246,0.05)"/>
      <rect x="764" y="316" width="30" height="3" rx="1" fill="rgba(251,191,36,0.07)"/>
      {/* arms slightly out */}
      <rect x="751" y="295" width="14" height="28" rx="4" fill="url(#silFill)"/>
      <rect x="793" y="295" width="14" height="28" rx="4" fill="url(#silFill)"/>
      <rect x="773" y="278" width="12" height="16" rx="4" fill="url(#silFill)"/>
      <ellipse cx="779" cy="268" rx="15" ry="16" fill="url(#silFill)"/>
      <ellipse cx="779" cy="255" rx="17" ry="7" fill="#0C1830"/>
      <rect x="763" y="252" width="32" height="8" rx="3" fill="#0D1E36"/>

      {/* WRISTBAND — left wrist */}
      <Wristband x={749} y={315} delay="1s"/>
    </g>

    {/* ground glow under worker 3 */}
    <ellipse cx="775" cy="372" rx="26" ry="5" fill="rgba(34,211,165,0.06)">
      <animate attributeName="opacity" values="0.5;1.0;0.5" dur="2.2s" begin="1s" repeatCount="indefinite"/>
    </ellipse>

  </svg>
);

// ─── MAIN COMPONENT ─────────────────────────────────────────────
const AuthLogin = () => {
  const [showPass, setShowPass] = useState(false);
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [passErr, setPassErr]   = useState("");
  const [error, setError]       = useState("");
  const [submitting, setSub]    = useState(false);
  const [imgFailed, setImgFailed] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth(); // ✅ context se login function


  const validate = () => {
    let ok = true;
    if (!email) { setEmailErr("Email is required"); ok = false; }
    else if (!/\S+@\S+\.\S+/.test(email)) { setEmailErr("Enter a valid email"); ok = false; }
    else setEmailErr("");
    if (!password) { setPassErr("Password is required"); ok = false; }
    else setPassErr("");
    return ok;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSub(true); setError("");
    try {
      // ── Restore real logic ──
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, { email, password });
      setAuthToken(data.token); setUserData(data.user); login(data.user);
      await requestNotificationPermissionAndGetToken();
      const routes = { admin:'/dashboard/admin', sales:'/dashboard/sales', operations:'/dashboard/operations', accounts:'/dashboard/accounts', ci_admin:'/commercial', customer:'/customer' };
      navigate(routes[data.user.role.toLowerCase()] || '/');
      //await new Promise(r => setTimeout(r, 1800));
      //setError("Preview mode — connect your real API to authenticate.");
    } catch { setError("Invalid email or password."); }
    finally { setSub(false); }
  };

  // ✅ FCM Token
  const requestNotificationPermissionAndGetToken = async () => {
    try {
      const permission = await Promise.race([
        Notification.requestPermission(),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Permission timeout")), 5000)
        ),
      ]);

      if (permission === "granted") {
        const registration = await serviceWorkerRegistration;
        const currentToken = await getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: registration,
        });
        if (currentToken) {
          await axios
            .post(
              `${process.env.REACT_APP_API_BASE_URL}/user/fcm-token`,
              { token: currentToken },
              getAuthHeader()
            )
            .catch((err) =>
              console.error("Failed to store FCM token:", err.message || err)
            );
        }
      }
    } catch (error) {
      console.error("Error retrieving FCM token:", error.message || error);
    }
  };

  return (
    <div className="al-root">
      <style>{STYLES}</style>
      <div className="al-boot"/>
      <div className="al-scanlines"/>

      {/* ══ LEFT ════════════════════════════════════════ */}
      <div className="al-left">
        <div className="al-deep-bg"/>
        <div className="al-noise"/>
        <div className="al-orb al-orb-1"/>
        <div className="al-orb al-orb-2"/>
        <div className="al-orb al-orb-3"/>
        <div className="al-shimmer"/>
        <div className="al-grid"/>
        <div className="al-hline" style={{ top:'35%', animation:'fadeIn 1.2s 1.8s both' }}/>
        <div className="al-hline" style={{ top:'60%', opacity:0.4, animation:'fadeIn 1.2s 2.0s both' }}/>

        {/* Particles */}
        {PARTICLES.map(p => (
          <div key={p.id} className="al-particle" style={{
            left:`${p.x}%`, top:`${p.y}%`,
            width:p.size, height:p.size,
            background:p.color,
            '--dx':p.dx, '--op':p.op,
            opacity:p.op,
            animationDelay:`${p.delay}s`,
            animationDuration:`${p.dur}s`,
          }}/>
        ))}

        {/* Illustrated scene */}
        <div className="al-scene" style={{ animation:'fadeIn 0.9s 1.2s both' }}>
          <Scene/>
        </div>

        {/* Text content */}
        <div className="al-left-inner">
          <div className="al-brand">
            <span className="al-brand-mark">SOWASH</span>
            <span className="al-brand-sub">Maintenance Solutions</span>
          </div>

          <div className="al-hero">
            <div className="al-hero-eyebrow">
              <span className="al-eyebrow-line"/>
              <span className="al-eyebrow-text">Field Operations Platform</span>
            </div>
            <div className="al-hero-title">
              Clean energy.<br/><em>Precision ops.</em>
            </div>
            <p className="al-hero-body">
              Track every panel, every team, every kilowatt —
              one command center built for the field.
            </p>
          </div>

          <div className="al-powered-wrap">
            <div className="al-powered-divider"/>
            <div className="al-powered-label">Powered by</div>
            <div className="al-powered-novaa">
              {!imgFailed ? (
                <img
                  src={novaLogo}
                  alt="NOVA"
                  className="al-novaa-img"
                  onError={() => setImgFailed(true)}
                />
              ) : (
                <div className="al-novaa-fallback">
                  <div className="al-novaa-icon">N</div>
                  <span className="al-novaa-word">NOVAA</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ══ DIVIDER ══════════════════════════════════════ */}
      <div className="al-divider">
        <div className="al-divider-gem"/>
      </div>

      {/* ══ RIGHT ════════════════════════════════════════ */}
      <div className="al-right">
        <div className="al-bracket al-bracket-tr"/>
        <div className="al-bracket al-bracket-bl"/>

        <div className="al-card">
          <div className="al-card-head">
            <div className="al-eyebrow-row">
              <div className="al-eyebrow-dash"/>
              <span className="al-eyebrow-tag">Secure Portal</span>
            </div>
            <div className="al-card-title">Welcome back.</div>
            <div className="al-card-sub">Sign in to access your dashboard and operations.</div>
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="al-field">
              <div className="al-label">Email Address</div>
              <div className="al-input-wrap">
                <span className="al-input-icon">✉</span>
                <input type="email" className={`al-input${emailErr?' has-error':''}`}
                  placeholder="you@sowash.pk" value={email}
                  onChange={e=>{setEmail(e.target.value);setEmailErr("");}}
                  autoComplete="email"/>
                <div className="al-uline"/>
              </div>
              {emailErr && <div className="al-error-msg">⚠ {emailErr}</div>}
            </div>

            <div className="al-field">
              <div className="al-label">
                <span>Password</span>
                <a href="/forgot-password">Forgot password?</a>
              </div>
              <div className="al-input-wrap">
                <span className="al-input-icon">🔑</span>
                <input type={showPass?'text':'password'} className={`al-input${passErr?' has-error':''}`}
                  placeholder="••••••••••" value={password}
                  onChange={e=>{setPassword(e.target.value);setPassErr("");}}
                  autoComplete="current-password" style={{paddingRight:42}}/>
                <button type="button" className="al-eye" onClick={()=>setShowPass(s=>!s)}>
                  {showPass?'🙈':'👁'}
                </button>
                <div className="al-uline"/>
              </div>
              {passErr && <div className="al-error-msg">⚠ {passErr}</div>}
            </div>

            {error && <div className="al-alert"><span>⚠</span>{error}</div>}

            <div className="al-field" style={{marginBottom:0}}>
              <button type="submit" className="al-btn" disabled={submitting}>
                <div className="al-btn-shine"/>
                {submitting?<><span className="al-spin"/>Authenticating…</>:'Sign In →'}
              </button>
            </div>
          </form>

          <div className="al-footer">
            Don't have an account?{' '}
            <a href="/signup">Contact your admin</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLogin;